module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAWCAYAAAArdgcFAAABYElEQVQ4jbXVvUscQRgH4MdgFRuLiEXAEJETBFEjVjFFQBASiCJiYZFG/wAtJEV6JSFNwEKSKkklNmKb1pCr0ohWIvgBglYGPBQ/IgO7shx3e8fe5gdbzAzz7O7MO7tNxWJRnXmGURzhRz1TmuuER/Az0Z7EWK1JD+rE18rabzCeBz6N1gr9H/LAP1fpL2CiEXwej1LGl/Cw2mByQ3vQiSdRZfRhsMbNw9PvYwt/sBO1f6MU46uYqgFVS3izl9EV5xSvw7K8bQCuljZ8CfiLnOE4hYB/+0/4RsA3sZAzvI3ZuBQ/4X1OcKiYAZwn63wRcw3CoRx7caXCIQqn8XtGuITnuI07Kp3Qg4z4P1wkOyrhQxnxlmitU/FCRjykKw1vj74tWdOfhj+u8aU8xk3KeCq+G21MeX5Fv7UOPMXHuNzKsp6G/8Ur7OEyqtsZDIfjjGsc4h26sYwTnGEFX+8l3AGymDooFZ6FrAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jl/jl-sc.png
// module id = uw9f
// module chunks = 90